import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import goodJobSvg from '../../images/icons/goodJob.svg';
import CircularProgress from '@material-ui/core/CircularProgress';
import Transition from './Transition';
import _ from 'lodash';
import {withStyles} from '@material-ui/core/styles';

const styles = {
	goodJobIcon: {
		display : 'inline-block',
		width : 50,
		height : 50,
		backgroundImage: `url('${goodJobSvg}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
	},
	title : {
		fontSize : 30,
		display: 'inline-block',
		verticalAlign: 'middle',
		paddingLeft: 5,
		paddingTop: 5,
	},
	inner : {
		padding : '10px 20px',
	},
	removeButton : {
		//verticalAlign : 'middle',
		//textDecoration: 'none',
		//marginBottom: 0,
		//borderRadius: 100,
		padding: '10px 35px',
		fontSize : 16,
		marginTop : 20,
		color : 'white',
		marginRight : 10,
		backgroundColor: `#f44336`,
	},
};

class DeletingDialog extends Component {
	render() {
		const {
			status,
			confirmingText,
			processingText,
			successText,
			open,
			onClose,
			onContinue,
			onConfirm,
			onCancel,
			classes,
		} = this.props;

		return (
			<div>
				<Dialog
					open={open}
					TransitionComponent={Transition}
					onClose={onClose}
				>
					<div style={styles.inner}>
						<DialogTitle>
							<div>
								{status === 'deleting' &&
								<div style={{display : 'flex', alignItems : 'center'}}>
									<CircularProgress />
									<span style={styles.title}>Deleting...</span>
								</div>
								}

								{status === 'done' &&
								<div>
									<div style={styles.goodJobIcon}/>
									<span style={styles.title}>Success!</span>
								</div>
								}
							</div>
						</DialogTitle>
						<DialogContent>
							<DialogContentText>
								<strong style={{fontSize:'120%'}}>
									{status === 'confirming' && confirmingText}
									{status === 'deleting' && processingText}
									{status === 'done' && successText}
								</strong>
							</DialogContentText>
						</DialogContent>
						<DialogActions>
							{status === 'confirming' && (
								<Fragment>
									<Button
										variant="contained"
										color="primary"
										className={classes.removeButton}
										onClick={onConfirm}
									>
										Yes, I want to remove this
									</Button>

									<Button variant="outlined" onClick={onCancel}>
										Close
									</Button>
								</Fragment>
							)}
							{status !== 'confirming' && (
								<Button
									disabled={status !== 'done'}
									onClick={onContinue}
									variant={"outlined"}
									color="primary"
								>
									Continue
								</Button>
							)}
						</DialogActions>
					</div>
				</Dialog>
			</div>
		);
	}
}

DeletingDialog.propTypes = {
	status : PropTypes.oneOf(['confirming', 'deleting', 'done']),
	open : PropTypes.bool,
	onClose : PropTypes.func,
	onContinue : PropTypes.func,
	onCancel: PropTypes.func,
	onConfirm: PropTypes.func,
	confirmingText: PropTypes.string,
	processingText : PropTypes.string,
	successText : PropTypes.string,
};

DeletingDialog.defaultProps = {
	confirmingText: 'Are you sure you want to delete this?',
	processingText : 'Processing...',
	successText : 'Save was successful'
};


export default _.flow([
	withStyles(styles, { withTheme: true }),
])(DeletingDialog);

